import getConfig from "next/config"

const runtimeConfig = getConfig()
const config = runtimeConfig?.publicRuntimeConfig || {}
const apiBaseUrl = config?.apiBaseUrl

export default apiBaseUrl
